import { AwsDocument } from "./aws-document";

export class CarAwsDocument extends AwsDocument {
	CarID:number = 0;
	public constructor(data?:any){
		super(data);
		if (!data) return;
		this.CarID = data.CarID;
	}
}